// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-radio[data-v-3d873820] .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(45, 183, 130, 0.5);\n}", ""]);
// Exports
module.exports = exports;
